export const DEFAULT_ENTRYPOINT = 'directLink';

/*
 * The entryPoint used when checkBookingPageIsPublished calls getBookingSessionData, to avoid logging false errors
 *  while repeating calls to getBookingSessionData, to validate IsPublished replicated, in the organizer page.
 */
export const ORGANIZER_CHECK_ISPUBLISHED_ENTRYPOINT: string = 'ORGANIZER_CHECK_ISPUBLISHED';

/*
 * The entryPoint used when getMailboxHashFromPayload calls getBookingSessionData, to avoid logging false errors
 *  while repeating calls to getBookingSessionData, to validate IsPublished replicated, in the organizer page.
 */
export const ORGANIZER_GET_MAILBOXHASH_ENTRYPOINT: string = 'ORGANIZER_GET_MAILBOXHASH';

/*
 * This entry point is user when masterPublishingCheck calls getBookingSessionData, to avoid logging false errors
 *  while repeating calls to getBookingSessionData, to validate IsPublished replicated, in the organizer page.
 */
export const ORGANIZER_MASTER_PUBLISHING_CHECK_ENTRYPOINT: string =
    'ORGANIZER_MASTER_PUBLISHING_CHECK';

/*
 * Number of times getBookingSessionData is called, while trying to discover IsPublished replicated, before it gets reported as an error.
 */
export const ORGANIZER_CHECK_ISPUBLISHED_MAXTRIES: number = 60;
